// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"b5dc1f43","498":"fb16386a","703":"51444e93"}[chunkId] + ".chunk.js";
};